module.exports = __webpack_public_path__ + "img/pic_draw@2x.767075f9.png";